module.exports = __webpack_public_path__ + "img/SI.15de825c.svg";